import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取用户列表
 *
 */
export const getUserList = () => {
  return request({
    url: env.ferryUrl + '/orderRefund/getUserList',
    method: 'GET'
  })
}

/**
 * 查询所有上架的线路
 *
 */
export const getLineList = () => {
  return request({
    url: env.ferryUrl + '/lineAdmin/getLineList',
    method: 'GET'
  })
}

/**
 * 获取退票详情
 * @param centralRefund
 */
export const selectRefundPage = (centralRefund) => {
  const { serviceType } = centralRefund
  return request({
    url: env.ferryUrl + `${serviceType === 3 ? '/express/order/refund/page' : '/orderRefund/page'}`,
    method: 'POST',
    data: centralRefund
  })
}

/**
 * 审核不通过
 * @param auditFailed
 */
export const authorFailed = (auditFailed) => {
  return request({
    url: env.ferryUrl + '/orderRefund/auditFailed',
    method: 'POST',
    data: auditFailed
  })
}

/**
 * 查看审核不通过原因
 * @param orderRefundInfo
 */
export const refundDetail = (orderRefundInfo) => {
  return request({
    url: env.ferryUrl + '/orderRefund/refundDetail',
    method: 'POST',
    data: orderRefundInfo
  })
}

/**
 * 审核是否通过确认信息
 * @param orderRefundInfo
 */
export const orderRefundConfirm = (orderRefundInfo) => {
  return request({
    url: env.ferryUrl + '/orderRefund/orderRefundConfirm',
    method: 'POST',
    data: orderRefundInfo
  })
}

/**
 * 审核通过
 * @param orderRefundInfo
 */
export const authorSuccess = (orderRefundInfo) => {
  return request({
    url: env.ferryUrl + '/orderRefund/approved',
    method: 'POST',
    data: orderRefundInfo
  })
}
/**
 * 审核通过
 * @param data
 */
export const revocation = (data) => {
  return request({
    url: env.ferryUrl + '/orderRefund/revocation',
    method: 'POST',
    data
  })
}
/**
 * 小件快运退款审核，撤销，通过，拒绝等
 * @param data
 */
export const expressRefundAudit = (data) => {
  return request({
    url: env.ferryUrl + '/express/order/refund/audit',
    method: 'POST',
    data
  })
}
/**
 * 确认退款详情
 * @param id
 */
export const refundConfirm = (id) => {
  return request({
    url: env.ferryUrl + `/express/order/refund/confirm/${id}`,
    method: 'GET'
  })
}
/**
 * 退款订单详情
 * @param id
 */
export const expressRefundInfo = (id) => {
  return request({
    url: env.ferryUrl + `/express/order/refund/info/${id}`,
    method: 'GET'
  })
}
